import api from './api';

const internalOrderService = {
    createInternalOrder: async (orderData) => {
        const response = await api.post('/internal-orders/create', orderData);
        return response.data;
    },
    getByParent: async (parentId) => {
        const response = await api.get(`/internal-orders/parent/${parentId}`);
        return response.data;
    },
    getById: async (id) => {
        const response = await api.get(`/internal-orders/${id}`);
        return response.data;
    },

    getAll: async (params = {}) => {
        const response = await api.get('/internal-orders/all', { params });
        return response.data;
    },
    getAnalytics: async (params = {}) => {
        const response = await api.get('/internal-orders/analytics', { params });
        return response.data;
    },
    linkOrder: async (id, parentInvoiceCode) => {
        const response = await api.post(`/internal-orders/${id}/link`, { parent_invoice_code: parentInvoiceCode });
        return response.data;
    },
    unlinkOrder: async (id) => {
        const response = await api.post(`/internal-orders/${id}/unlink`);
        return response.data;
    }
};

export default internalOrderService;
